<template>
  <hc-base-index
    ref="hcBaseIndexRef"
    :pageTitle="pageTitle"
    :flowCode="flowCode"
    :defaultStateOptions="stateOptions"
    @openCreateDialog="openCreateDialog"
    @viewDetail="viewDetail"
  >
    <template #extend="{ hcFlowId }">
      <hc-phonghop-create-dialog
        :isOpen="isOpenDialogCreate"
        :flowId="flowId"
        :flowCode="flowCode"
        v-if="isEnableDialogCreate"
        @dialogClosed="isEnableDialogCreate = false"
        @closeDialog="isOpenDialogCreate = false"
        @success="createSuccess"
      />
    </template>
  </hc-base-index>
</template>

<script>
import constants from "../../../constants";
import goBackMixin from "../../../mixins/goBackMixin";
import h from "../../../services/h";
import hanhchinhService from "../../../services/hanhchinhService";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import utils from "../../../services/utils";
import HcBaseIndex from "../khachsan/hc-base-index";
import HcPhonghopCreateDialog from "./PhongHop_Form";

export default {
  name: "hc-phonghop-index",
  mixins: [goBackMixin],
  components: { HcPhonghopCreateDialog, HcBaseIndex },

  data() {
    return {
      flowCode: constants.HC_FLOW.FLOW_CODE.PHONG_HOP,
      pageTitle: "Đặt phòng họp",
      isOpenDialogCreate: false,
      isEnableDialogCreate: false,
      isOpenDialogReport: false,
      isEnableDialogReport: false,
      hcFlow: null,
      flowId: null,
      stateOptions: null,
    };
  },

  watch: {
    isOpenDialogCreate(newValue) {
      if (newValue) this.isEnableDialogCreate = true;
    },
  },

  created() {
    this.initStateOptions();
    this.getProcedureInformation();
  },

  computed: {
    isQuanLy() {
      return (this.$store.getters.userDeptRole && 
        this.$store.getters.userDeptRole.roleCode ===
        constants.ROLE.CODE.PHONG_HOP.QL_PHONG_HOP
      );
    },
  },

  methods: {
    initStateOptions() {
      this.stateOptions = h.collect(
        [
          "-1",
          !this.isQuanLy
            ? constants.HC_STATE.STATE_CODE.MAY_BAY.DA_DANG_KY
            : constants.HC_STATE.STATE_CODE.MAY_BAY.CHO_PHE_DUYET,
          constants.HC_STATE.STATE_CODE.MAY_BAY.DA_PHE_DUYET,
          constants.HC_STATE.STATE_CODE.MAY_BAY.HUY,
        ],
        (state) => {
          return {
            id: state,
            name:
              state === "-1"
                ? "Tất cả"
                : hanhChinhUtils.getMayBayStateLabel(state),
          };
        }
      );
    },

    getProcedureInformation() {
      return hanhchinhService
        .getProcedureInformation(this.flowCode)
        .then((response) => {
          if (response.data.hcFlow !== null) {
            this.hcFlow = response.data.hcFlow;
            this.flowId = this.hcFlow.id;
          }
        });
    },

    openCreateDialog() {
      this.isOpenDialogCreate = true;
    },

    createSuccess() {
      this.isOpenDialogCreate = false;
      this.doSearch();
    },

    doSearch() {
      this.$refs.hcBaseIndexRef.doSearch();
    },

    viewDetail(e) {
      let caseMasterId = e.caseMasterId;
      let params = utils.merge(this.$route.params, { id: caseMasterId });
      this.$router.push({
        name: "adminstration-detail",
        params: params,
        query: this.$route.query,
      });
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/adminstration/phonghop/hc-phonghop-index.vue